import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "total", "normal", "percentage" ]

  calculate() {
    const total = parseFloat(this.totalTarget.value) || 0
    const normal = parseFloat(this.normalTarget.value) || 0

    if (normal > 0) {
      const result = (total / normal) * 100
      this.percentageTarget.value = result
    } else {
      this.percentageTarget.value = 0
    }
  }
}
